import { useEffect, useState } from "react";
import { TextField, IconButton, Box, Tooltip } from "@mui/material";
import { Search } from "@mui/icons-material";
import moment from "moment";

const DateStartAndEndSame = ({ onSearch }) => {
  const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");

  const [startDate, setStartDate] = useState(yesterday);
  const [endDate, setEndDate] = useState(yesterday);

  const formatDate = (dateStr) => moment(dateStr, "YYYY-MM-DD").format("DD-MM-YYYY");

  const handleSearch = () => {

    if (onSearch) {

      onSearch(formatDate(startDate), formatDate(endDate));
    }
  };

  useEffect(() => {
    if (onSearch) {
      onSearch(formatDate(startDate), formatDate(endDate));
    }
  }, [onSearch]);

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="flex-end"
      gap={1}
      p={{ xs: 0, md: 1 }}
    >
      <TextField
        size="small"
        name="startDate"
        label="Start Date"
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ max: moment().format("YYYY-MM-DD") }}
        variant="outlined"
      />

      <TextField
        size="small"
        name="endDate"
        label="End Date"
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ max: moment().format("YYYY-MM-DD") }}
        variant="outlined"
      />

      <Tooltip title="Search">
        <IconButton color="primary" onClick={handleSearch}>
          <Search />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default DateStartAndEndSame;

